import { render, staticRenderFns } from "./historyClaim.vue?vue&type=template&id=a57d5eec&"
import script from "./historyClaim.vue?vue&type=script&lang=js&"
export * from "./historyClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports